import React, { useState, useEffect, useContext } from 'react'
import { ResultsTableCon, ResultText } from './styles'
import { TeamContext } from '../../../../Context'
import { SectionHeading } from '../../../../Components/Headers/SectionHeading'
import { getShortDate, getTeamEvents } from '../../../../Utils'
import { EventGQL, fetchSeasonEvents } from '../../../../Api'
import { EVENTS_YEAR, STATS_YEAR } from '../../../../Config/League/league.config'
import { TableHeader } from '../../../../Components/Tables/TableHeader'

export const GameResults: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { teamId, team, events } = useContext(TeamContext)!
  const [results, setResults] = useState<EventGQL[]>([])

  useEffect(() => {
    if (!team) {
      return
    } else {
      getResults()
    }
  }, [events])

  const getOpponenet = (event: EventGQL) => {
    if (event.awayTeam.fullName === team?.fullName) {
      //team is away
      return event.homeTeam.fullName
    } else {
      return event.awayTeam.fullName
    }
  }

  const getWinStatus = (event: EventGQL) => {
    if (event.eventStatus < 2) return ''
    if (event.awayTeam.fullName === team?.fullName) {
      //team is away
      return event.visitorScore > event.homeScore
        ? 'W'
        : event.visitorScore < event.homeScore
        ? 'L'
        : 'T'
    } else {
      //team is home
      return event.homeScore > event.visitorScore
        ? 'W'
        : event.homeScore < event.visitorScore
        ? 'L'
        : 'T'
    }
  }

  const getResults = async () => {
    if (events.length < 1) return
    const firstEvent = events[0]
    const firstEventStatus = firstEvent.eventStatus
    if (firstEventStatus === 0) {
      //Season hasn't started, show previous year results
      const lastSeason = EVENTS_YEAR - 1
      try {
        const seasonEvents = await fetchSeasonEvents(lastSeason)
        if (seasonEvents && seasonEvents.length > 0) {
          const evs = getTeamEvents(seasonEvents, teamId).filter(
            (ev) => ev.eventStatus > 1
          )
          setResults(evs)
        }
      } catch (err) {
        console.log(err)
      }
    } else {
      let filtered = events.filter((ev) => ev.eventStatus > 1)
      setResults(filtered)
    }
  }

  return (
    <>
      {results.length > 0 && (
        <div>
          <SectionHeading teamColor={team?.teamColor} lowMargin>
            <strong>{results[0].year || STATS_YEAR}</strong>{' '}
            {results[0].seasonSegment === 'champseries'
              ? 'Champ Series Results'
              : 'Results'}
          </SectionHeading>
          <ResultsTableCon>
            <thead>
              <tr>
                <TableHeader ariaLabel="Game">Game</TableHeader>
                <TableHeader ariaLabel="Result">Result</TableHeader>
              </tr>
            </thead>
            <tbody>
              {results.map((ev, idx) => (
                <tr key={idx}>
                  <td>
                    {getShortDate(ev.startTime)} vs. {getOpponenet(ev)}
                  </td>
                  <td>
                    <ResultText resultStatus={getWinStatus(ev)}>
                      {getWinStatus(ev)}
                    </ResultText>{' '}
                    {ev.eventStatus > 0 ? `${ev.visitorScore} - ${ev.homeScore}` : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </ResultsTableCon>
        </div>
      )}
    </>
  )
}
